<template lang="pug">
  .evaluate-vendor(v-loading="loading")
    template(v-if="!view")
      title-bar {{ $t('评价供应商') }}
      div(style="margin-left: 20px")
        evaluation(
          :data="editData"
          :view="view"
          :validate="validate"
          ref="evaluation"
        )

    template(
      v-for="item in viewStructure"
      v-if="viewData[item.key]"
    )
      title-bar {{ $t(item.title) }}
      div(style="margin-left: 20px")
        evaluation(
          :data="viewData[item.key]"
          :view="view"
        )

    el-row(style="margin-left: 20px")
      el-col(
        :offset="4"
        :span="20"
      )
        footer-button(
          v-if="!view"
          @confirm="onConfirm"
          @cancel="$router.push('/campaign/process')"
        )
</template>

<script>
import TitleBar from '@/components/TitleBar'
import FooterButton from '@/components/FooterButton'
import Evaluation from '@/components/Evaluation'
import axios from 'axios'
import { format4backend } from '@/umcc/util'

const market = {
  key: 'marketing_evaluation',
  title: '评价供应商-市场部'
}

const purchase = {
  key: 'purchase_evaluation',
  title: '评价供应商-采购部'
}

const it = {
  key: 'it_evaluation',
  title: '评价供应商-IT部'
}

const viewStructure = {
  '20': [purchase, market, it], // 采购
  '30': [market, purchase, it], // 市场
  '40': [it, market, purchase] // IT
}

export default {
  components: {
    TitleBar,
    FooterButton,
    Evaluation
  },
  data () {
    return {
      editData: {
        satisfaction: 0,
        creativity: 0,
        execution: 0,
        development: 0,
        cost_control: 0,
        remark: ''
      },
      viewData: {},
      view: true,
      loading: true,
      validate: false
    }
  },
  computed: {
    viewStructure () {
      return viewStructure[this.$store.getters.user.struct_group_type]
    },
    campaignId () {
      return this.$store.state.campaign.id
    }
  },
  mounted () {
    axios.get('/management/subfinal/getVendorEvaluation', {
      params: {
        sub_final_scope_id: this.$store.state.campaign.subFinalScopeId
      }
    })
      .then(res => {
        if (res.is_evaluated) this.viewData = res
        else this.view = false
        this.loading = false
      })
  },
  methods: {
    async onConfirm () {
      this.validate = true
      const validateResult = await this.$refs.evaluation.$validator.validate()
      if (!validateResult) return
      const taskId = this.$store.state.campaign.taskId
      const params = {
        vendor_evaluation: {
          sub_final_scope_id: this.$store.state.campaign.subFinalScopeId,
          satisfaction: this.editData.satisfaction,
          creativity: this.editData.creativity,
          execution: this.editData.execution,
          development: this.editData.development,
          cost_control: this.editData.cost_control,
          remark: this.editData.remark
        },
        servlet_path: this.$route.path,
        campaign_id: this.$store.state.campaign.id
      }
      if (taskId) params.task_id = taskId
      if (Object.values(params.vendor_evaluation).includes(0)) return
      this.loading = true
      axios.post('/management/subfinal/saveVendorEvaluation', format4backend(params))
        .then(res => {
          this.$store.dispatch('campaign/updateCampaignSurvey')
          this.loading = false
          this.$router.push('/campaign/process')
        })
    }
  }
}
</script>
